import { FC } from 'react';
import styled from 'styled-components';

import { TrackingStatusEnum } from 'order/wizard/orderTracking/enums/TrackingStatusEnum';
import { Badge } from 'shared/components/Badge';
import {
  catskillWhite,
  chambray,
  fairPink,
  gallery,
  highland,
  kashmirBlue,
  linkWater,
  nevada,
  saltpan,
  taupe,
  valencia,
  wildSand,
  yellowLight,
} from 'shared/config/Colors';

const statusColors: Record<
  TrackingStatusEnum,
  { bgColor: string; txtColor: string }
> = {
  [TrackingStatusEnum.NOT_SHIPPED]: { bgColor: gallery, txtColor: nevada },
  [TrackingStatusEnum.LABEL_CREATED]: { bgColor: wildSand, txtColor: nevada },
  [TrackingStatusEnum.IN_TRANSIT]: {
    bgColor: catskillWhite,
    txtColor: kashmirBlue,
  },
  [TrackingStatusEnum.OUT_FOR_DELIVERY]: {
    bgColor: linkWater,
    txtColor: chambray,
  },
  [TrackingStatusEnum.DELIVERED]: { bgColor: saltpan, txtColor: highland },
  [TrackingStatusEnum.DELAYED]: { bgColor: yellowLight, txtColor: taupe },
  [TrackingStatusEnum.EXCEPTION]: { bgColor: fairPink, txtColor: valencia },
  [TrackingStatusEnum.CANCELLED]: { bgColor: fairPink, txtColor: valencia },
  [TrackingStatusEnum.UNAVAILABLE]: { bgColor: gallery, txtColor: nevada },
};

const StatusBadge = styled(Badge)`
  letter-spacing: 0.3px;
  padding: 2px 8px;
  text-transform: uppercase;
  white-space: nowrap;
`;

interface TrackingStatusBadgeProps {
  status: TrackingStatusEnum;
  label?: string;
}

export const TrackingStatusBadge: FC<TrackingStatusBadgeProps> = ({
  status,
  label,
}) => (
  <StatusBadge small {...statusColors[status]}>
    {label ?? status}
  </StatusBadge>
);
